module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-horizontal-a82e3d6d1b969ddfbe6af44693b3b0f2.svg";